import type { Mixin } from "./define-component.js";

// withExternalCSS injectiert ein <link rel=stylesheet>-Tag in die
// ShadowRoot. URL kann statisch oder per Callback aus host-Attributen
// abgeleitet sein.
export function withExternalCSS(opts: { href: string | ((host: HTMLElement) => string | null) }): Mixin {
  return (host, ctx) => ({
    connect() {
      if (!ctx.shadowRoot) return;
      const href = typeof opts.href === "function" ? opts.href(host) : opts.href;
      if (!href) return;

      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      ctx.shadowRoot.prepend(link);
    },
  });
}
